export const DATADOG_CONFIG = {
  env: process.env.NODE_ENV,
  site: 'datadoghq.com',
  service: 'kj-uploader',
  forwardErrorsToLogs: true,
  sampleRate: 100,
  silentMultipleInit: true,
};
